/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */
import { App } from './App';
import './printHooks';
import { IS_WEB } from './utils/platformUtils';
import { checkForVersionUpdate } from './utils/versionCheck';
import { createRoot } from 'react-dom/client';
import { toast } from 'react-toastify';

declare global {
  interface Window {
    toast: typeof toast;
  }
}

window.toast = toast;

if (window.location.pathname.startsWith('/officer')) {
  document.body.classList.add('officer-only');
  // just in case cache is messed up
}

function start() {
  const root = createRoot(document.getElementById('root')!);
  root.render(<App />);
  checkForVersionUpdate();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}

// Register service worker if supported and running in web
if ('serviceWorker' in navigator && IS_WEB) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service.worker.js')
      .then(registration => {
        console.log(
          'Service Worker registered successfully:',
          registration.scope,
        );
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

setInterval(
  checkForVersionUpdate,
  24 * 60 * 60 * 1000, // Check every 24 hours
);
